// extracted by mini-css-extract-plugin
export default {"pageHeadingWrapper":"pageHeadingWrapper-jh99E"};